import toast from 'react-hot-toast';
import { downloadJson, fileStamp, showNotes } from './backupShared';

// ─── Nachbereitung einer Baum-Wiederherstellung ──────────────────────────────
//
// Gleich, ob die Datei hochgeladen oder von der Storage Box geholt wurde:
// Sicherungspunkt anbieten, Ergebnis melden, Abweichungen einzeln zeigen.

interface TreeRestoreResponse {
  createdNew?: boolean;
  safetySnapshot?: unknown;
  files?: { written?: number; missing?: number };
  notes?: unknown;
}

export function announceTreeRestore(data: TreeRestoreResponse) {
  // Beim Überschreiben kommt der vorherige Stand zurück – sofort anbieten,
  // damit auch dieser Schritt umkehrbar bleibt.
  if (data.safetySnapshot) {
    downloadJson(data.safetySnapshot, `sicherungspunkt-vor-wiederherstellung-${fileStamp()}.json`);
  }

  const written = data.files?.written ?? 0;
  const dateien = written ? `, ${written} Dateien geschrieben` : '';
  toast.success(
    data.createdNew
      ? `Als neuer Stammbaum angelegt${dateien}.`
      : `Stammbaum wiederhergestellt${dateien}. Sicherungspunkt heruntergeladen.`,
  );

  if ((data.files?.missing ?? 0) > 0) {
    toast(`${data.files?.missing} Archiv-Dateien waren im Backup nicht enthalten.`, {
      icon: '⚠️',
      duration: 8000,
    });
  }
  showNotes(data.notes);
}
